import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * External dependencies
 */
import { cloneElement, Component } from '@wordpress/element';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
/**
 * A form component to handle form state and provide input helper props.
 */

var Form =
/*#__PURE__*/
function (_Component) {
  _inherits(Form, _Component);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this));
    _this.state = {
      values: props.initialValues,
      errors: props.errors,
      touched: props.touched
    };
    _this.getInputProps = _this.getInputProps.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.setTouched = _this.setTouched.bind(_assertThisInitialized(_this));
    _this.setValue = _this.setValue.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validate();
    }
  }, {
    key: "isValidForm",
    value: function () {
      var _isValidForm = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.validate();

              case 2:
                return _context.abrupt("return", !Object.keys(this.state.errors).length);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function isValidForm() {
        return _isValidForm.apply(this, arguments);
      }

      return isValidForm;
    }()
  }, {
    key: "validate",
    value: function validate() {
      var values = this.state.values;
      var errors = this.props.validate(values);
      this.setState({
        errors: errors
      });
    }
  }, {
    key: "setValue",
    value: function setValue(name, value) {
      this.setState(function (prevState) {
        return {
          values: _objectSpread({}, prevState.values, _defineProperty({}, name, value))
        };
      }, this.validate);
    }
  }, {
    key: "setTouched",
    value: function setTouched(name) {
      var touched = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.setState(function (prevState) {
        return {
          touched: _objectSpread({}, prevState.touched, _defineProperty({}, name, touched))
        };
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(name, value) {
      var values = this.state.values; // Handle native events.

      if (value.target) {
        if ('checkbox' === value.target.type) {
          this.setValue(name, !values[name]);
        } else {
          this.setValue(name, value.target.value);
        }
      } else {
        this.setValue(name, value);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(name) {
      this.setTouched(name);
    }
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var values, touched;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                values = this.state.values;
                touched = {};
                Object.keys(values).map(function (name) {
                  return touched[name] = true;
                });
                this.setState({
                  touched: touched
                });
                _context2.next = 6;
                return this.isValidForm();

              case 6:
                if (!_context2.sent) {
                  _context2.next = 8;
                  break;
                }

                this.props.onSubmitCallback(values);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }

      return handleSubmit;
    }()
  }, {
    key: "getInputProps",
    value: function getInputProps(name) {
      var _this2 = this;

      var _this$state = this.state,
          errors = _this$state.errors,
          touched = _this$state.touched,
          values = _this$state.values;
      return {
        value: values[name],
        checked: Boolean(values[name]),
        selected: values[name],
        onChange: function onChange(value) {
          return _this2.handleChange(name, value);
        },
        onBlur: function onBlur() {
          return _this2.handleBlur(name);
        },
        className: touched[name] && errors[name] ? 'has-error' : null,
        help: touched[name] ? errors[name] : null
      };
    }
  }, {
    key: "getStateAndHelpers",
    value: function getStateAndHelpers() {
      var _this$state2 = this.state,
          values = _this$state2.values,
          errors = _this$state2.errors,
          touched = _this$state2.touched;
      return {
        values: values,
        errors: errors,
        touched: touched,
        setTouched: this.setTouched,
        setValue: this.setValue,
        handleSubmit: this.handleSubmit,
        getInputProps: this.getInputProps,
        isValidForm: !Object.keys(errors).length
      };
    }
  }, {
    key: "render",
    value: function render() {
      var element = this.props.children(this.getStateAndHelpers());
      return cloneElement(element);
    }
  }]);

  return Form;
}(Component);

Form.propTypes = {
  /**
   * A renderable component in which to pass this component's state and helpers.
   * Generally a number of input or other form elements.
   */
  children: PropTypes.any,

  /**
   * Object of all initial errors to store in state.
   */
  errors: PropTypes.object,

  /**
   * Object key:value pair list of all initial field values.
   */
  initialValues: PropTypes.object.isRequired,

  /**
   * Function to call when a form is submitted with valid fields.
   */
  onSubmitCallback: PropTypes.func,

  /**
   * A function that is passed a list of all values and
   * should return an `errors` object with error response.
   */
  validate: PropTypes.func
};
Form.defaultProps = {
  errors: {},
  initialValues: {},
  onSubmitCallback: noop,
  touched: {},
  validate: noop
};
export default Form;
//# sourceMappingURL=index.js.map